import { useMemo } from "react";

interface ICountryAddressProps {
    dataCy?: string;
    initialCountryLookupId: string;
    isDisabled?: boolean;
    onCountryChange: (value: string) => void;
}

interface ICountryState {
    CountryLookupId: string;
    CountryLocalizedName: string
}

export function CountrySelect(props: Readonly<ICountryAddressProps>): JSX.Element {
    const { suggestedCountries, allCountries } = useMemo(() => {
        const suggestedCountriesBySites: ICountryState[] = sessionStore.getCurrentEmployee().getAllSites().map(p => ({
            CountryLookupId: p.getCountryLookupId(),
            CountryLocalizedName: cacheStore.GetLocalizedValueByLookupId(p.getCountryLookupId())
        })).distinctByProperty(p => p.CountryLookupId).sortByProperty(p => p.CountryLocalizedName);

        const allSortedCountries: ICountryState[] = cacheStore.GetCountryLookups().map(p => ({
            CountryLookupId: p.LookupID,
            CountryLocalizedName: cacheStore.GetLocalizedValueByLookupId(p.LookupID).trim()
        })).sortByProperty(p => p.CountryLocalizedName);

        return {
            suggestedCountries: suggestedCountriesBySites,
            allCountries: allSortedCountries
        };
    }, []);

    return (
        <select
            data-cy={props.dataCy}
            className="form-control myle-control"
            value={props.initialCountryLookupId}
            onChange={e => props.onCountryChange(e.target.value)}
            disabled={props.isDisabled}
        >
            {suggestedCountries?.length > 0 && (
                <>
                    {suggestedCountries?.map(country => (
                        <option key={country.CountryLookupId} value={country.CountryLookupId}>
                            {country.CountryLocalizedName}
                        </option>
                    ))}
                </>
            )}

            {allCountries?.map((country: ICountryState) => (
                <option key={country.CountryLookupId} value={country.CountryLookupId}>
                    {country.CountryLocalizedName}
                </option>
            ))}
        </select>
    );
}
